var spoiler_default = {
  "fontElementMap": "OeYIo",
  "hideText": "b35Xe",
  "onHoverText": "_-0Tmd",
  "hideBlock": "AVFXa",
  "smallBlur": "vbTOE",
  "mediumBlur": "ypdtF",
  "largeBlur": "yIjqB",
  "hideBlock_gallery": "_6DJoG",
  "overlay": "Wymod",
  "overlay_gallery": "w7Osb",
  "revealSpoilerBtn": "Hk3AO",
  "isMobile": "_3Cbqw",
  "onHoverBtn": "KbXVs",
  "spoilerWrapper": "fnaQH",
  "spoilerDescription": "uj6mn",
  "spoilerContainer": "ICOmX",
  "spoilerContainer_Gallery": "-R1T8"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
